// extracted by mini-css-extract-plugin
module.exports = {"input_item":"reportForm_input_item__2uU3K","button_group":"reportForm_button_group__3zvAf","report_button":"reportForm_report_button__vmBdP","form":"reportForm_form__254xC"};